(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["metropolis-purchase-summary"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('metropolis-purchase-summary')){customElements.define('metropolis-purchase-summary',class extends HTMLElement{connectedCallback(){this.scope=this.closest('product-component');this.variants=JSON.parse(this.querySelector('script').textContent);this.refresh=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};this.scope?.addEventListener('change',this.refresh);this.scope?.addEventListener('input',this.refresh);this.scope?.addEventListener('click',this.refresh);this.observer=new MutationObserver(this.refresh);if(this.scope)this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked']});this.update();}update(){const form=this.scope?.querySelector('form[action*="/cart/add"]');if(!form)return;const id=Number(form.querySelector('[name="id"]')?.value);const variant=this.variants.find(v=>v.id===id);if(!variant)return;const qty=Math.max(1,Number(form.querySelector('[name="quantity"]')?.value)||1);const planControl=[...form.querySelectorAll('[name="selling_plan"]')].find(el=>!el.disabled&&(!(el.type==='radio'||el.type==='checkbox')||el.checked));const planId=Number(planControl?.value)||0;const allocation=variant.plans.find(p=>p.id===planId);const total=(allocation?.price??variant.price)*qty;const values={'.metropolis-purchase-summary__label':planId?this.dataset.recurring:this.dataset.once,'.metropolis-purchase-summary__price':new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(total/100),'.metropolis-purchase-summary__delivery':planId?this.dataset.delivery:''};for(const [selector,value]of Object.entries(values)){const target=this.querySelector(selector);if(target.textContent!==value)target.textContent=value;}}disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();for(const event of ['change','input','click'])this.scope?.removeEventListener(event,this.refresh);}});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropolis-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('metropolis-size-guide')) {
  customElements.define('metropolis-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-component');
      this.update = () => {
        this.scope?.querySelectorAll('.kaching-subscriptions__dropdown-trigger-label').forEach(label => {
          const original = label.textContent.trim();
          const frequency = original.replace(/^Deliver every:\s*/i, '');
          const display = frequency.charAt(0).toUpperCase() + frequency.slice(1);
          if (label.dataset.frequency !== display) label.dataset.frequency = display;
          const trigger = label.closest('button');
          if (trigger) trigger.setAttribute('aria-label', 'Deliver every: ' + display);
        });

        const largeBag = this.scope?.querySelector('variant-picker input[value="5 lb"]')?.closest('label');
        if (largeBag && !largeBag.querySelector('.metropolis-shipping-badge') && this.dataset.shippingLabel) {
          const badge = document.createElement('span'); badge.className = 'metropolis-shipping-badge'; badge.textContent = this.dataset.shippingLabel; largeBag.append(badge);
        }
        const selected = this.scope?.querySelector('variant-picker input[type="radio"][data-option-name="Size"]:checked');
        if (!selected) return;
        const template = [...this.querySelectorAll('template[data-size]')].find(item => item.dataset.size === selected.value);
        if (template && this.querySelector('p').textContent !== template.content.textContent.trim()) this.querySelector('p').textContent = template.content.textContent.trim();
      };
      this.scope?.addEventListener('change', this.update);
      this.observer = new MutationObserver(this.update);
      if(this.scope) this.observer.observe(this.scope,{childList:true,subtree:true});
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.scope?.removeEventListener('change', this.update); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
